import * as React from 'react'

import { cn } from '@/lib/utils'

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                'tw:file:text-foreground tw:placeholder:text-muted-foreground tw:selection:bg-muted-foreground/70 tw:selection:text-primary-foreground tw:dark:bg-background tw:border-[#3B5168] tw:flex tw:h-9 tw:w-full tw:min-w-0 tw:rounded-xs tw:border tw:bg-transparent tw:px-3 tw:py-1 tw:!text-sm tw:shadow-xs tw:transition-[color,box-shadow] tw:outline-none tw:file:inline-flex tw:file:h-7 tw:file:border-0 tw:file:bg-transparent tw:file:text-sm tw:file:font-medium tw:disabled:pointer-events-none tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:md:text-sm',
                'tw:focus-visible:border-ring tw:focus-visible:border-blue-500 tw:focus-visible:border-[1px]',
                'tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive',
                className,
            )}
            ref={ref}
            {...props}
        />
    )
})

export { Input }
